import React from "react"
import { Button, Space, Rate, Typography, Popconfirm } from "antd"
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"
import { TFunction } from "i18next"
import { ServiceReview } from "../../../../domain/entities/ServiceReview"
import { ServiceReviewsViewModel } from "../ServiceReviewsViewModel"

const { Text, Paragraph } = Typography

export const getServiceReviewsColumns = (
	t: TFunction,
	viewModel: ServiceReviewsViewModel,
	handleEditReview: (record: ServiceReview) => void,
	handleDeleteReview: (reviewId: number) => void
) => [
	{
		title: t("dataTableHeaders.rating"),
		dataIndex: "rating",
		key: "rating",
		width: 150,
		render: (rating: number) => (
			<div>
				<Rate disabled defaultValue={rating || 0} />
			</div>
		)
	},
	{
		title: t("dataTableHeaders.user"),
		dataIndex: "user",
		key: "user",
		width: 200,
		render: (user: ServiceReview["user"]) => (
			<div>
				<Text strong>{user?.name || t("table.unknownUser")}</Text>
				{user?.email && (
					<div>
						<Text type="secondary" style={{ fontSize: "12px" }}>
							{user.email}
						</Text>
					</div>
				)}
			</div>
		)
	},
	{
		title: t("dataTableHeaders.comment"),
		dataIndex: "review",
		key: "review",
		render: (review: string) => (
			<Paragraph
				ellipsis={{ rows: 3, expandable: true, symbol: t("table.seeMore") }}
				style={{ margin: 0, maxWidth: "300px" }}
			>
				{review || t("table.noComment")}
			</Paragraph>
		)
	},
	{
		title: t("dataTableHeaders.date"),
		dataIndex: "date",
		key: "date",
		width: 150,
		render: (date: Date) => <Text>{viewModel.formatDate(date)}</Text>
	},
	{
		title: t("dataTableHeaders.actions"),
		key: "actions",
		width: 100,
		render: (_: any, record: ServiceReview) => (
			<Space>
				<Button
					type="text"
					size="small"
					icon={<EditOutlined />}
					onClick={() => handleEditReview(record)}
					style={{ color: "#1890ff" }}
				/>
				<Popconfirm
					title={t("confirmDelete.title")}
					description={t("confirmDelete.description")}
					onConfirm={() => handleDeleteReview(record.id)}
					okText={t("confirmDelete.okText")}
					cancelText={t("confirmDelete.cancelText")}
				>
					<Button type="text" size="small" icon={<DeleteOutlined />} style={{ color: "#ff4d4f" }} />
				</Popconfirm>
			</Space>
		)
	}
]
